<template>
  <div class="mypage-ec-site-connect-error-parts">
    <h3 class="mypage-ec-site-connect-error-parts__title" v-if="errorData.title">
      {{ errorData.title }}
    </h3>
    <p class="mypage-ec-site-connect-error-parts__description" v-html="errorData.description" />
    <mypage-ec-site-connect-contact-parts
      class="mypage-ec-site-connect-error-parts__contact"
      v-if="errorData.hasContact"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import MypageEcSiteConnectContactParts from '@/components/MypageEcSiteConnectPage/MypageEcSitePane/parts/MypageEcSiteConnectContactParts.vue'

interface ErrorData {
  // タイトル
  title: string | null
  // 説明
  description: string
  // 問い合わせフォームを表示するかどうか
  hasContact: boolean
}

export default defineComponent({
  name: 'MypageEcSiteConnectErrorParts',
  components: { MypageEcSiteConnectContactParts },
  props: {
    errorData: {
      type: Object as PropType<ErrorData>,
      required: true,
    },
  },
})
</script>

<style scoped lang="scss">
.mypage-ec-site-connect-error-parts {
  &__title {
    font-size: 13px;
    font-weight: 700;
    color: $red;
    letter-spacing: 0.04em;
  }

  &__description {
    font-size: 13px;
    font-weight: 500;
    color: $red;
    letter-spacing: 0.04em;
    white-space: pre-wrap;
  }

  &__contact {
    margin-top: 24px;
  }
}
</style>
